import { createContext, ReactNode, useContext } from 'react';

import {
  BeneficiaryDesignationSuggestionsByTier,
  useBeneficiaryDesignationSuggestions,
} from '../hooks/useBeneficiaryDesignationSuggestions';

const BeneficiaryDesignationSuggestionsContext =
  createContext<BeneficiaryDesignationSuggestionsByTier>({
    primary: [],
    contingent: [],
    loading: false,
    refetch: () => {},
  });

/**
 * Fetches the account's AI beneficiary-designation suggestions ONCE for the
 * whole editor and exposes the primary/contingent split. Mounted at the form
 * root so both tier matchers share a single query — the editor renders one
 * "Confirm recipients" matcher per tier, and without this each would issue its
 * own identical `cache-and-network` fetch.
 */
export function BeneficiaryDesignationSuggestionsProvider({
  entityId,
  children,
}: {
  entityId: string | null | undefined;
  children: ReactNode;
}) {
  const value = useBeneficiaryDesignationSuggestions({ entityId });

  return (
    <BeneficiaryDesignationSuggestionsContext.Provider value={value}>
      {children}
    </BeneficiaryDesignationSuggestionsContext.Provider>
  );
}

/**
 * Reads the editor's AI beneficiary-designation suggestions. Returns empty
 * buckets outside the provider so a matcher mounted without one simply shows no
 * card rather than throwing.
 */
export function useBeneficiaryDesignationSuggestionsContext() {
  return useContext(BeneficiaryDesignationSuggestionsContext);
}
